module.exports = __webpack_public_path__ + "img/icon-sb-call-us-boutique-color-48.89bd1be.svg";